<template><div><h1>VUX V2.1.1Rc.2 发布日志</h1>
<h2><a href="/zh-CN/components/group.html">Group</a></h2>
<ul><li>[feature] 支持 margin-top 等 less 变量</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] 修复部分机子不支持 for of 遍历</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[feature] 支持更多 less 变量</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] 修复按钮文字颜色变量</li>
</ul>
<h2><a href="/zh-CN/components/x-img.html">XImg</a></h2>
<ul><li>[feature] 支持延迟执行属性 delay</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.2 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.2-219.vue?f156035a